import actionTypes from "./actions.types";
export default {
  updateActionLoading: state =>
    state.type === actionTypes.UPDATE_ACTION_REQUEST,
  updateActionSuccess: state =>
    state.type === actionTypes.UPDATE_ACTION_SUCCESS,
  updateActionFailed: state => state.type === actionTypes.UPDATE_ACTION_FAILED,

  addActionLoading: state => state.type === actionTypes.ADD_ACTION_REQUEST,
  addActionSuccess: state => state.type === actionTypes.ADD_ACTION_SUCCESS,
  addActionFailed: state => state.type === actionTypes.ADD_ACTION_FAILED,

  fetchActionsLoading: state =>
    state.type === actionTypes.FETCH_ACTIONS_REQUEST,
  fetchActionsSuccess: state =>
    state.type === actionTypes.FETCH_ACTIONS_SUCCESS,
  fetchActionsFailed: state => state.type === actionTypes.FETCH_ACTIONS_FAILED,

  deleteActionsLoading: state =>
    state.type === actionTypes.DELETE_ACTION_REQUEST,
  deleteActionsSuccess: state =>
    state.type === actionTypes.DELETE_ACTIONS_SUCCESS,
  deleteActionsFailed: state => state.type === actionTypes.DELETE_ACTIONS_FAILED
};
